import { useCallback, useState } from 'react';
import { FormList } from '@Components/Common/FormComponent';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { raiApprovedSenderEmailEntriesSelector } from '@Policy/store/filters/riskAI/selectors';
// import { generalExport } from '@Policy/utils/fns';
import { ExchangeOnlinePolicyItem } from '@Policy/utils/types';
import { isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';
import ImportModal from '../../../Components/ImportModal';
import { generalExport } from '@Policy/utils/fns';
import { Stack, Text } from '@tonic-one/react';

const RiskAiSenders = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const { t } = useTranslation();
  // get state from store
  const raiApprovedSenderEmailEnabled = policySelector(
    (s) => s.tmRiskAiFilters.raiApprovedSenderEmailEnabled
  );
  const approvedSenderList = contextSelector(
    raiApprovedSenderEmailEntriesSelector,
    isEqual
  );
  // config
  const approvedListMaxCount = contextSelector(
    (s) => s.config.limitation.approvedListMaxCount
  );
  // get action from store
  const setRiskAiState = contextSelector((s) => s.setRiskAiState);
  const addRiskAiApprovedSender = contextSelector(
    (s) => s.addRiskAiApprovedSender
  );
  const removeRiskAiApprovedSender = contextSelector(
    (s) => s.removeRiskAiApprovedSender
  );
  const importRiskAiApprovedSender = contextSelector(
    (s) => s.importRiskAiApprovedSender
  );

  // local state
  // approved sender list
  // status change
  const handleApprovedSenderEmailEnabledChange = useCallback(() => {
    setRiskAiState({
      raiApprovedSenderEmailEnabled: raiApprovedSenderEmailEnabled ? 0 : 1,
    });
  }, [raiApprovedSenderEmailEnabled, setRiskAiState]);
  // export
  const handleApporvedSenderListExport = useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-sender-list',
    });
  }, []);
  // import
  const [
    isApprovedSenderImportModalVisible,
    setIsApprovedSenderImportModalVisible,
  ] = useState(false);

  const handleApprovedSenderImport = useCallback(
    (entries: any) => {
      console.log('import entries', entries);
      importRiskAiApprovedSender(entries as string[]);
      setIsApprovedSenderImportModalVisible(false);
    },
    [importRiskAiApprovedSender]
  );

  return (
    <Stack gap="4x">
      <Text size="md">{t('policy.title.senders')}</Text>
      <FormList
        onAdd={addRiskAiApprovedSender}
        onDelete={removeRiskAiApprovedSender}
        onExport={handleApporvedSenderListExport}
        onImport={() => setIsApprovedSenderImportModalVisible(true)}
        list={approvedSenderList}
        limit={approvedListMaxCount}
        status={!!raiApprovedSenderEmailEnabled}
        setStatus={handleApprovedSenderEmailEnabledChange}
        label={t('policy.approvedSenderList.title')}
        description={t('policy.approvedSenderList.supportWildcardDesc')}
        containerProps={{
          ml: 0,
        }}
      />
      <ImportModal
        isVisible={isApprovedSenderImportModalVisible}
        onClose={() => setIsApprovedSenderImportModalVisible(false)}
        onImport={handleApprovedSenderImport}
      />
    </Stack>
  );
};

export default RiskAiSenders;
